export default __webpack_public_path__ + "static/shrub-champion-75bdc1cba00937b5d462d4b75ef2a06d.png";